import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取股票列表
 * @param data
 */
export function search(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/stock/Search`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取股票列表
 * @param stockListCode 股票列表
 */
export function getStockPrice(stockListCode) {
  var requestData = {
    custom: {
      goodsId: stockListCode
    },
    fieldsId: [0, 1, 6, 84, 85],
    limitSize: stockListCode.length
  }
  return axios({
    url: 'https://emapp.emoney.cn/transfer/bs.m.emoney.cn?X-Protocol-Id=2100',
    // url: 'https://mbs.emoney.cn?X-Protocol-Id=2100',
    method: 'post',
    dataType: 'json',
    headers: {
      'Content-Type': 'text/plain'
    },
    data: requestData
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
